export default __webpack_public_path__ + "static/media/moose.21e16514.png";